const SessionCardSkeleton: React.FC = () => (
  <div
    className="flex h-full flex-col rounded-[1.75rem] border border-[#E8EFEB] bg-white p-6 shadow-[0_18px_40px_rgba(58,88,89,0.08)]"
    aria-hidden="true"
  >
    <div className="flex items-center gap-3">
      <div className="h-10 w-10 shrink-0 animate-pulse rounded-full bg-[#E8EFEB]" />
      <div className="h-5 w-32 animate-pulse rounded-full bg-[#E8EFEB]" />
    </div>
    <div className="mt-4 space-y-2">
      <div className="h-3 w-full animate-pulse rounded bg-[#F0F4F1]" />
      <div className="h-3 w-3/4 animate-pulse rounded bg-[#F0F4F1]" />
      <div className="h-3 w-1/2 animate-pulse rounded bg-[#F0F4F1]" />
    </div>
    <div className="mt-6 h-10 w-full animate-pulse rounded-full bg-[#D5E1DB]" />
  </div>
);

export default SessionCardSkeleton;
